import { render, staticRenderFns } from "./SinglePage.vue?vue&type=template&id=0e6aad44&scoped=true&"
import script from "./SinglePage.vue?vue&type=script&lang=js&"
export * from "./SinglePage.vue?vue&type=script&lang=js&"
import style0 from "./SinglePage.vue?vue&type=style&index=0&id=0e6aad44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6aad44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VImg})
